import React from "react";
import { Box } from "@chakra-ui/react";

export const WaveBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Dark background base */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #0a1628 0%, #1a2a4a 50%, #0d1a30 100%)"
      />

      {/* Wave layers - extra wide to hide edges during animation */}
      <svg
        className="wave-svg"
        viewBox="0 0 2880 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: 0,
          left: "-50%",
          width: "200%",
          height: "100%",
        }}
      >
        <defs>
          <linearGradient id="waveGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1e3a5f" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#0d2137" stopOpacity="0.6" />
          </linearGradient>
          <linearGradient id="waveGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#2a4a7f" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#152a45" stopOpacity="0.4" />
          </linearGradient>
          <linearGradient id="waveGrad3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#3a5a9f" stopOpacity="0.4" />
            <stop offset="100%" stopColor="#1a3a5f" stopOpacity="0.3" />
          </linearGradient>
        </defs>

        {/* Back wave - slowest */}
        <path
          className="wave wave-back"
          fill="url(#waveGrad3)"
          d="M0,600 C180,550 360,650 540,600 C720,550 900,650 1080,600 C1260,550 1440,650 1620,600 C1800,550 1980,650 2160,600 C2340,550 2520,650 2700,600 C2880,550 2880,650 2880,600 L2880,800 L0,800 Z"
        />

        {/* Middle wave */}
        <path
          className="wave wave-middle"
          fill="url(#waveGrad2)"
          d="M0,650 C180,600 360,700 540,650 C720,600 900,700 1080,650 C1260,600 1440,700 1620,650 C1800,600 1980,700 2160,650 C2340,600 2520,700 2700,650 C2880,600 2880,700 2880,650 L2880,800 L0,800 Z"
        />

        {/* Front wave - fastest */}
        <path
          className="wave wave-front"
          fill="url(#waveGrad1)"
          d="M0,700 C180,670 360,730 540,700 C720,670 900,730 1080,700 C1260,670 1440,730 1620,700 C1800,670 1980,730 2160,700 C2340,670 2520,730 2700,700 C2880,670 2880,730 2880,700 L2880,800 L0,800 Z"
        />
      </svg>

      {/* Subtle stars/particles */}
      <Box className="stars" position="absolute" width="100%" height="60%" top="0" left="0" />
    </Box>
  );
};

export default WaveBackground;
